import styled from 'styled-components';

export const Nav = styled.nav`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  padding: 1.25rem 0 0.75rem;
  gap: 1rem;
`;

export const LogoButton = styled.button`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0 1.25rem;
  border: 0;
  background: transparent;
  cursor: pointer;
`;

export const Logo = styled.img`
  width: 7.5rem;
  height: auto;
`;

export const LinksViewport = styled.div`
  flex: 1 1 0;
  width: 100%;
  min-height: 0;
  overflow: hidden;

  > ul {
    height: 100%;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
`;

export const UpdateArea = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 0.2rem;
  padding: 0 1rem;

  button {
    padding: 0;
    border: 0;
    color: white;
    background: transparent;
    text-align: center;
    cursor: pointer;
  }

  .cache {
    font-size: 0.8rem;
  }

  .version {
    font-size: 0.7rem;
  }
`;
